import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'app/store'
import InsightContentType from 'components/insightContent/enum/InsightContentType'
import { ServiceResultWith } from 'schemas/ServiceResultSchema'
import { InsightCount } from 'schemas/action/InsightCountSchema'
import { AnnotatedMetricResult } from 'schemas/AnnotatedMetricResultSchema'
import { MAX_TERMS } from 'components/insightContent/Overview/DetailItems/Fluctuation/PopularTerms/constants'

// eslint-disable-next-line import/prefer-default-export
export const selectFluctuationPrerequisite = createSelector(
  [
    (state: RootState) =>
      state.insightContent.contents?.[InsightContentType.FLUCTUATION_POPULAR_TERMS_PREREQUISITE]
        ?.data?.[0],
    (state: RootState) =>
      state.insightContent.contents?.[InsightContentType.FLUCTUATION_POPULAR_TERMS_PREREQUISITE]
        ?.data?.[1]
  ],
  (
    metricData: ServiceResultWith<AnnotatedMetricResult>,
    insightData: ServiceResultWith<InsightCount>
  ) => ({
    totalMetricValue: metricData?.results?.[0].data?.metrics?.[0]?.dataset?.[0]?.set?.[0],
    insightSets: insightData?.results?.[0].data?.insights?.[0]?.dataset?.[0]?.set?.slice(
      0,
      MAX_TERMS
    )
  })
)
